<template>
  <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
    <div class="bg-white rounded-lg p-6">
      <p>{{ message }}</p>
      <button @click="$emit('close')" class="mt-4 bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">
        Schließen
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MessageModal',
  props: ['message'],
  emits: ['close']
};
</script>